import React from 'react';
import '../graphStyles.scss';
import NoDataFound from "../../NoDataFound";
import { ExportCSVButton } from "../../ExportCSVButton";
import DateRangeFilter from "../DateRangeFilter/DateRangeFilter";
import useDateRangeFilter from "../DateRangeFilter/useDateRangeFilter";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export function NumberOfUniqueVisitorsGraph({ uniqueBrowsers, engaged, weeks, display }) {
  const { filteredWeeks, filteredData, onFilterChange } = useDateRangeFilter({
    weeks,
    dataArrays: { uniqueBrowsers, engaged },
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
        onHover: function (event, legendItem) {
          document.getElementById("chart").style.cursor = 'pointer';
        },
        onLeave: function (event, legendItem) {
          document.getElementById("chart").style.cursor = 'default';
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: 'Week',
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 10 : 13;
            },
          },
        },
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
      },
      y: {
        title: {
          display: true,
          text: 'Number of users',
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 10 : 13;
            },
          },
        },
        ticks: {
          font: {
            size: function () {
              return window.innerWidth < 830 && window.innerWidth > 570 ? 9 : 13;
            },
          },
        },
      },
    },
  };

  const labels = filteredWeeks;

  const data = {
    labels,
    datasets: [
      {
        label: 'Engaged',
        data: filteredData.engaged,
        backgroundColor: 'rgba(0, 50, 248, 0.83)',
        hoverBackgroundColor: 'rgba(0, 50, 248, 0.83)',
      },
      {
        label: 'Total',
        data: filteredData.uniqueBrowsers,
        backgroundColor: 'rgba(0, 230, 248, 0.95)',
        hoverBackgroundColor: 'rgba(0, 230, 248, 0.95)',
      },
    ],
  };

  const allData = [
    ["Number of visitors engaged", ...filteredData.engaged],
    ["Total Visitors", ...filteredData.uniqueBrowsers],
  ];

  return (
    <div className="graph">
      <div className="graph__title flex flex-col md:flex-row justify-between items-center">
        <h4 className="text-lg md:text-xl font-semibold text-center md:text-left mb-2 md:mb-0">
          Number of unique visitors
        </h4>
        <div className="flex items-center gap-2 flex-wrap justify-end pr-3">
          <DateRangeFilter weeks={weeks} onFilterChange={onFilterChange} />
          <ExportCSVButton
            allData={allData}
            name={"Number of Unique Visitors"}
            className="w-full md:w-auto"
          />
        </div>
      </div>

      {weeks.length === 0 ? (
        <NoDataFound />
      ) : (
        <div className="relative w-full h-64 md:h-96">
          <Bar
            className={`chart ${display === "dashboard" ? "dashboard__graph" : ""}`}
            id="chart"
            options={options}
            data={data}
          />
        </div>
      )}
    </div>
  );
}
